<template>
  <el-dialog
      v-model="isDialogVisible"
      :title="props.fundName ? props.fundName + ' 五档' : '五档详情'"
      @close="onClose"
      width="80%"
  >
    <div class="fund-info">
      <div class="header">
        <p>数据更新时间：{{ updateTime }}</p>
        <p>fundCode：{{ props.fundCode }}</p>
        <p>fundName：{{ props.fundName }}</p>
        <p>昨日成交量：{{ props.yesterdayVolume }}</p>
        <p>估值：{{ gz }}</p>
        <p>大于七天赎回费率：{{ props.redemptionFeeRate }}</p>
        <p>赎回到账日期：{{ props.redemptionDate }}</p>
        <p>申购费率：{{ props.subscriptionFeeRate }}</p>
        <p>申购到账日期：{{ props.subscriptionDate }}</p>
        <p>最大申购金额：{{ props.maxSubscriptionAmount }}</p>
      </div>
      <table class="price-table">
        <thead>
        <tr>
          <th>五档</th>
          <th>场内价格</th>
          <th>溢价率</th>
          <th>委托金额（万）</th>
          <th>费后收益率</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in tableData" :key="index"  :class="{ 'gray-row': parseFloat(String(row.yield)) < 0 }">
          <td>{{ row.level }}</td>
          <td>{{ row.price }}</td>
          <td>{{ row.premiumRate }}</td>
          <td>{{ row.commission }}</td>
          <td>{{ row.yield }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, watch, defineProps,defineEmits } from 'vue';
import axios from "axios";

const props = defineProps({
  fundCode: {
    type: Number,
    default: 0
  },
  fundName: {
    type: String,
    default: ""
  },
  yesterdayVolume: {
    type: Number,
    default: 0
  },
  // valuation: {
  //   type: Number,
  //   default: 0
  // },
  redemptionFeeRate: {
    type: Number,
    default: 0
  },
  redemptionDate: {
    type: String,
    default: ""
  },
  subscriptionFeeRate: {
    type: Number,
    default: 0
  },
  subscriptionDate: {
    type: String,
    default: ""
  },
  maxSubscriptionAmount: {
    type: Number,
    default: 0
  },
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible']);

const isDialogVisible = ref(props.visible);
const updateTime = ref('');
const gz = ref(0.0);
let intervalId = null;

const tableData = ref([]);

// 监听 visible 属性的变化
watch(
    () => props.visible,
    (newValue) => {
      isDialogVisible.value = newValue;
      if (newValue) {
        fetchData();
        startPolling();
      } else {
        stopPolling();
      }
    }
);

const startPolling = () => {
  if (!intervalId) {
    intervalId = setInterval(fetchData, 30000);
  }
};

const stopPolling = () => {
  clearInterval(intervalId);
  intervalId = null;
};

const fetchData = () => {
  if (!props.fundCode) {
    return;
  }
  const url = process.env.VUE_APP_API_BASE_URL + "/arbitrage/five?fundcode=" + props.fundCode;
  console.debug('fetchData url:', url);
  axios.get(url).then(response => {
    console.debug('fetchData response:', response);
    const data = response.data ?? {};
    updateTime.value = data.updateTime ?? '';
    gz.value = data.gz ?? 0;
    tableData.value = Array.isArray(data.tableData) ? data.tableData : [];
  }).catch(error => {
    console.error('fetchData Error fetching fund data:', error);
  });
};

const onClose = () => {
  emit('update:visible', false);
};
</script>

<style scoped>

.price-table th, .price-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

th {
  background-color: #f2f2f2;
}

.gray-row {
  background-color: #f2f2f2;
}
</style>